module.exports = "/_next/static/images/mx-216d2ed600701aa4e417b8a169fb09e1.svg";